/**
 * An on/off switch. For settings that take effect as a state, not an action:
 * notifications, who can sign in where. Use a button for anything that *does* something.
 */

export function Switch({
  checked,
  onChange,
  label,
  disabled,
}: {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border transition-colors disabled:opacity-50 ${
        checked ? 'bg-primary border-primary' : 'bg-surface-alt border-border'
      }`}
    >
      <span
        className={`inline-block h-[18px] w-[18px] rounded-full bg-white shadow transition-transform ${
          checked ? 'translate-x-[22px] rtl:-translate-x-[22px]' : 'translate-x-[3px] rtl:-translate-x-[3px]'
        }`}
      />
    </button>
  );
}
